import {ThemeNames} from '../themes';
import {Theme} from '../interfaces/themes';
import {ProductNames} from '../constants';

export const wtaConfig = {
  chatConfig: {
    theme: (ThemeNames.wta as Theme),
    productName: ProductNames.web2app,
  },
  roomConfig: {
    type: 'ClarioWeb',
  }
};
